import { render, staticRenderFns } from "./NewAgingFlatform.vue?vue&type=template&id=3fdbe600&scoped=true"
import script from "./NewAgingFlatform.vue?vue&type=script&lang=js"
export * from "./NewAgingFlatform.vue?vue&type=script&lang=js"
import style0 from "./NewAgingFlatform.vue?vue&type=style&index=0&id=3fdbe600&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdbe600",
  null
  
)

export default component.exports